<template functional>
  <div>
    <label v-if="props.topLabel">{{props.topLabel}}</label>
    <div class="input-group" :class="props.classWidth">
      <div v-if="props.label && labelType === 'prefix'" class="input-group-prepend">
        <span class="input-group-text">{{props.label}}</span>
      </div>
      <input
        v-bind="$attrs"
        class="form-control"
        :class="props.customClass"
        :name="props.name"
        :value="props.value"
        :placeholder="props.placeholder"
        v-on="listeners" />
      <div v-if="props.label" class="input-group-append">
        <span class="input-group-text">{{props.label}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextInputGroup',
  props: {
    value: { type: String, default: null },
    label: { type: String },
    labelType: { type: String, default: 'prefix' },
    customClass: { type: String, default: '' },
    topLabel: { type: String },
    name: { type: String },
    classWidth: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

label {
  margin-bottom: 0.15em !important;
}

.input-group.width-50 {
  width: 50%;
}
@media (max-width: 576px) {
  .input-group-prepend {
    width: 50%;
  }

  .input-group.width-50 {
    width: 100%;
  }
}
</style>
